const t = {
  name: "ChevronsLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.41436 12.0002L12.4144 8.00015L11.0002 6.58594L5.58594 12.0002L11.0001 17.4144L12.4144 16.0002L8.41436 12.0002Z" fill="currentColor"/>
<path d="M14.4144 12.0002L18.4144 8.00015L17.0002 6.58594L11.5859 12.0001L17.0002 17.4144L18.4144 16.0002L14.4144 12.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronsLeft
};
